import { Stack, Typography } from "@mui/material"

interface EnvironmentAlertProps {
  color: "warning" | "error" | "info" | "success"
  text: string
}
const EnvironmentAlert = ({ color, text }: EnvironmentAlertProps) => {
  return (
    <Stack
      id="environment-alert"
      alignItems="center"
      sx={{
        position: "fixed",
        width: "100%",
        height: "100%",
        borderColor: (theme) => theme.palette[color].main,
        borderWidth: 6,
        borderStyle: "solid",
        zIndex: (theme) => theme.zIndex.appBar * 100,
        pointerEvents: "none",
      }}
    >
      <Stack
        sx={{
          minWidth: 200,
          height: 35,
          bgcolor: (theme) => theme.palette[color].main,
          borderRadius: "0 0 20px 20px",
          position: "relative",
          transformOrigin: "center bottom",
          transform: "perspective(220px) rotateX(-20deg)",
          mt: -0.2,
          "&::before": {
            content: '""',
            position: "absolute",
            width: 30,
            height: 30,
            background: (theme) =>
              `radial-gradient(circle at 0 100%, transparent 30px, ${theme.palette[color].main} 30px)`,

            left: -27,
          },
          "&::after": {
            content: '""',
            position: "absolute",
            width: 30,
            height: 30,
            background: (theme) =>
              `radial-gradient(circle at 100% 100%, transparent 30px, ${theme.palette[color].main} 30px)`,
            right: -27,
          },
        }}
      ></Stack>
      <Typography
        variant="h6"
        sx={{
          position: "absolute",
          top: 4,
          color: (theme) => theme.palette[color].contrastText,
        }}
      >
        {text}
      </Typography>
    </Stack>
  )
}

export default EnvironmentAlert
